import {ICssClass} from "./GenericTableCssClass";

/** Classe contant les éléments d'une ligne du tableau - Doit être étendu pour chaque classe d'alimentation du tableau */
export interface IRow {
    Id: string;
    Name: string;
    Selected: boolean;
    IsLockedSelect: boolean;
    CssClasses: ICssClass[];
}

/** Définition d'une ligne */
export class Row implements IRow {
    private _id: string;
    private _name: string;
    private _selected: boolean;
    private _isLockedSelect: boolean;
    private _cssClasses: ICssClass[];

    public constructor(id: string, name: string, data: Partial<IRow>) {
        this._id = id;
        this._name = name;
        this._selected = data?.Selected ?? false;
        this._isLockedSelect = data?.IsLockedSelect ?? false;
        this._cssClasses = data?.CssClasses ?? [];
    }

    /** Identifiant unique de la donnée */
    public get Id(): string {
        return this._id;
    }

    public set Id(value: string) {
        this._id = value;
    }

    /** Nom de la donnée */
    public get Name(): string {
        return this._name;
    }

    public set Name(value: string) {
        this._name = value;
    }

    /** Est-elle sélectionné */
    public get Selected() {
        return this._selected;
    }

    public set Selected(value: boolean) {
        this._selected = value;
    }

    /** Sa selection est-elle verrouillé en écriture */
    public get IsLockedSelect() {
        return this._isLockedSelect;
    }

    public set IsLockedSelect(value: boolean) {
        this._isLockedSelect = value;
    }

    /** Sa selection est-elle verrouillé en écriture */
    public get CssClasses() {
        return this._cssClasses;
    }

    public set CssClasses(value: ICssClass[]) {
        this._cssClasses = value;
    }
}
